import styled from '@emotion/styled'
import { breakpoint, calcRem, metrics } from '../../__styling'

export const StyledTaboolaContainer = styled('div')(({ theme }) => ({
    marginTop:
        theme.kind === 'sevennews'
            ? `${calcRem(theme.margins.lg)}!important`
            : 0,

    padding:
        theme.kind === 'thenightly'
            ? `${calcRem(metrics.thenightly.margins.m2l)} !important`
            : 0,

    [breakpoint('mlg')]: {
        padding: '0 !important',
    },
}))
